import storeModule from '../../../store-module'
import { defineStore } from 'pinia'

const url = 'active-offers/dashboard/broker-performance'

export default defineStore(
  'active-offers-broker-performance',
  storeModule.createStoreModule('active-offers-broker-performance', {
    fetchListURL: url,
    fetchFiltersURL: `${url}/filters`
  })
)
